import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const DeploymentHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "DplymtHub" */ "./DeploymentHubApp");
    return { default: namedExport.DeploymentHubApp };
});

export const DeploymentHub: TeamAppConfig = {
    title: "Deployment Hub",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Deployment Hub",
    team: "DeploymentCore",
    publicId: "Exchange\\Deployment(Multi-Tenant)",
    owner: "o365deploycore@microsoft.com",
    role: "*",
    tags: [],
    app: DeploymentHubApp,
    path: "/DeploymentHub"
};
